var ht = Object.defineProperty;
var U = (r) => {
  throw TypeError(r);
};
var ct = (r, t, s) => t in r ? ht(r, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[t] = s;
var _ = (r, t, s) => ct(r, typeof t != "symbol" ? t + "" : t, s), D = (r, t, s) => t.has(r) || U("Cannot " + s);
var e = (r, t, s) => (D(r, t, "read from private field"), s ? s.call(r) : t.get(r)), d = (r, t, s) => t.has(r) ? U("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(r) : t.set(r, s), u = (r, t, s, n) => (D(r, t, "write to private field"), n ? n.call(r, s) : t.set(r, s), s), a = (r, t, s) => (D(r, t, "access private method"), s);
import { l as ut, d as dt, T as E, R as lt, G as ft, k as F, o as mt, e as x, c as I, f as gt } from "./vidstack-8s6P_CC9.js";
function Tt() {
  return "https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1";
}
function vt() {
  var r;
  return !!((r = window.cast) != null && r.framework);
}
function wt() {
  var r, t;
  return !!((t = (r = window.chrome) == null ? void 0 : r.cast) != null && t.isAvailable);
}
function At() {
  return L().getCastState() === cast.framework.CastState.CONNECTED;
}
function L() {
  return window.cast.framework.CastContext.getInstance();
}
function q() {
  return L().getCurrentSession();
}
function B() {
  var r;
  return (r = q()) == null ? void 0 : r.getSessionObj().media[0];
}
function j(r) {
  var s;
  return ((s = B()) == null ? void 0 : s.media.contentId) === (r == null ? void 0 : r.src);
}
function kt() {
  return {
    language: "en-US",
    autoJoinPolicy: chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED,
    receiverApplicationId: chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID,
    resumeSavedSession: !0,
    androidReceiverCompatible: !0
  };
}
function Ct(r) {
  return `Google Cast Error Code: ${r}`;
}
function yt(r, t) {
  return ut(L(), r, t);
}
var o, h, C, y, A, T, p, S, v, k, f, w, i, Y, J, P, K, b, z, Q, W, M, N, R, O, X, Z, tt, G, et, V, st, $, m, it, nt, H, at;
class Et {
  constructor(t, s) {
    d(this, i);
    _(this, "$$PROVIDER_TYPE", "GOOGLE_CAST");
    _(this, "scope", dt());
    d(this, o);
    d(this, h);
    d(this, C);
    d(this, y, null);
    d(this, A, "disconnected");
    d(this, T, 0);
    d(this, p, 0);
    d(this, S, new E(0, 0));
    d(this, v, new lt(a(this, i, Q).bind(this)));
    d(this, k);
    d(this, f, null);
    d(this, w, !1);
    u(this, o, t), u(this, h, s), u(this, C, new ft(t, s, a(this, i, at).bind(this)));
  }
  get type() {
    return "google-cast";
  }
  get currentSrc() {
    return e(this, y);
  }
  /**
   * The Google Cast remote player.
   *
   * @see {@link https://developers.google.com/cast/docs/reference/web_sender/cast.framework.RemotePlayer}
   */
  get player() {
    return e(this, o);
  }
  /**
   * @see {@link https://developers.google.com/cast/docs/reference/web_sender/cast.framework.CastContext}
   */
  get cast() {
    return L();
  }
  /**
   * @see {@link https://developers.google.com/cast/docs/reference/web_sender/cast.framework.CastSession}
   */
  get session() {
    return q();
  }
  /**
   * @see {@link https://developers.google.com/cast/docs/reference/web_sender/chrome.cast.media.Media}
   */
  get media() {
    return B();
  }
  /**
   * Whether the current Google Cast session belongs to this provider.
   */
  get hasActiveSession() {
    return j(e(this, y));
  }
  setup() {
    a(this, i, Y).call(this), a(this, i, J).call(this), e(this, C).setup(), e(this, h).notify("provider-setup", this);
  }
  async play() {
    var t;
    if (!(!e(this, o).isPaused && !e(this, w))) {
      if (e(this, w)) {
        await a(this, i, H).call(this, !1, 0);
        return;
      }
      (t = e(this, o).controller) == null || t.playOrPause();
    }
  }
  async pause() {
    var t;
    e(this, o).isPaused || (t = e(this, o).controller) == null || t.playOrPause();
  }
  getMediaStatus(t) {
    return new Promise((s, n) => {
      var c;
      (c = this.media) == null || c.getStatus(t, s, n);
    });
  }
  setMuted(t) {
    var n;
    (t && !e(this, o).isMuted || !t && e(this, o).isMuted) && ((n = e(this, o).controller) == null || n.muteOrUnmute());
  }
  setCurrentTime(t) {
    var s;
    e(this, o).currentTime = t, e(this, h).notify("seeking", t), (s = e(this, o).controller) == null || s.seek();
  }
  setVolume(t) {
    var s;
    e(this, o).volumeLevel = t, (s = e(this, o).controller) == null || s.setVolumeLevel();
  }
  async loadSource(t) {
    var c;
    if (((c = e(this, f)) == null ? void 0 : c.src) !== t && u(this, f, null), j(t)) {
      a(this, i, K).call(this), u(this, y, t);
      return;
    }
    e(this, h).notify("load-start");
    const s = a(this, i, nt).call(this, t), n = await this.session.loadMedia(s);
    if (n) {
      u(this, y, null), e(this, h).notify("error", Error(Ct(n)));
      return;
    }
    u(this, y, t);
  }
  destroy() {
    a(this, i, P).call(this), a(this, i, b).call(this);
  }
}
o = new WeakMap(), h = new WeakMap(), C = new WeakMap(), y = new WeakMap(), A = new WeakMap(), T = new WeakMap(), p = new WeakMap(), S = new WeakMap(), v = new WeakMap(), k = new WeakMap(), f = new WeakMap(), w = new WeakMap(), i = new WeakSet(), Y = function() {
  yt(
    cast.framework.CastContextEventType.CAST_STATE_CHANGED,
    a(this, i, M).bind(this)
  );
}, J = function() {
  const t = cast.framework.RemotePlayerEventType, s = {
    [t.IS_CONNECTED_CHANGED]: a(this, i, M),
    [t.IS_MEDIA_LOADED_CHANGED]: a(this, i, N),
    [t.CAN_CONTROL_VOLUME_CHANGED]: a(this, i, R),
    [t.CAN_SEEK_CHANGED]: a(this, i, O),
    [t.DURATION_CHANGED]: a(this, i, tt),
    [t.IS_MUTED_CHANGED]: a(this, i, G),
    [t.VOLUME_LEVEL_CHANGED]: a(this, i, G),
    [t.IS_PAUSED_CHANGED]: a(this, i, et),
    [t.LIVE_SEEKABLE_RANGE_CHANGED]: a(this, i, V),
    [t.PLAYER_STATE_CHANGED]: a(this, i, st)
  };
  u(this, k, s);
  const n = a(this, i, W).bind(this);
  for (const c of F(s))
    e(this, o).controller.addEventListener(c, n);
  mt(() => {
    for (const c of F(s))
      e(this, o).controller.removeEventListener(c, n);
  });
}, P = function() {
  e(this, f) || (u(this, p, 0), u(this, S, new E(0, 0))), e(this, v).stop(), u(this, T, 0), u(this, f, null);
}, K = function() {
  const t = new x("resume-session", { detail: this.session });
  a(this, i, N).call(this, t);
  const { muted: s, volume: n, savedState: c } = e(this, h).$state, l = c();
  this.setCurrentTime(Math.max(e(this, o).currentTime, (l == null ? void 0 : l.currentTime) ?? 0)), this.setMuted(s()), this.setVolume(n()), (l == null ? void 0 : l.paused) === !1 && this.play();
}, b = function() {
  this.cast.endCurrentSession(!0);
  const { remotePlaybackLoader: t } = e(this, h).$state;
  t.set(null);
}, z = function() {
  const { savedState: t } = e(this, h).$state;
  t.set({
    paused: e(this, o).isPaused,
    currentTime: e(this, o).currentTime
  }), a(this, i, b).call(this);
}, Q = function() {
  a(this, i, Z).call(this);
}, W = function(t) {
  e(this, k)[t.type].call(this, t);
}, M = function(t) {
  const s = this.cast.getCastState(), n = s === cast.framework.CastState.CONNECTED ? "connected" : s === cast.framework.CastState.CONNECTING ? "connecting" : "disconnected";
  if (e(this, A) === n) return;
  const c = { type: "google-cast", state: n }, l = a(this, i, m).call(this, t);
  u(this, A, n), e(this, h).notify("remote-playback-change", c, l), n === "disconnected" && a(this, i, z).call(this);
}, N = function(t) {
  if (!!!e(this, o).isMediaLoaded) return;
  const n = I(e(this, h).$state.source);
  Promise.resolve().then(() => {
    if (n !== I(e(this, h).$state.source) || !e(this, o).isMediaLoaded) return;
    a(this, i, P).call(this);
    const c = e(this, o).duration;
    u(this, S, new E(0, c));
    const l = {
      provider: this,
      duration: c,
      buffered: new E(0, 0),
      seekable: a(this, i, $).call(this)
    }, g = a(this, i, m).call(this, t);
    e(this, h).notify("loaded-metadata", void 0, g), e(this, h).notify("loaded-data", void 0, g), e(this, h).notify("can-play", l, g), a(this, i, R).call(this), a(this, i, O).call(this, t);
    const { volume: rt, muted: ot } = e(this, h).$state;
    this.setVolume(rt()), this.setMuted(ot()), e(this, v).start(), e(this, C).syncRemoteTracks(g), e(this, C).syncRemoteActiveIds(g);
  });
}, R = function() {
  e(this, h).$state.canSetVolume.set(e(this, o).canControlVolume);
}, O = function(t) {
  const s = a(this, i, m).call(this, t);
  e(this, h).notify("stream-type-change", a(this, i, X).call(this), s);
}, X = function() {
  var s;
  return ((s = e(this, o).mediaInfo) == null ? void 0 : s.streamType) === chrome.cast.media.StreamType.LIVE ? e(this, o).canSeek ? "live:dvr" : "live" : "on-demand";
}, Z = function() {
  if (e(this, f)) return;
  const t = e(this, o).currentTime;
  t !== e(this, T) && (e(this, h).notify("time-change", t), t > e(this, p) && (u(this, p, t), a(this, i, V).call(this)), e(this, h).$state.seeking() && e(this, h).notify("seeked", t), u(this, T, t));
}, tt = function(t) {
  if (!e(this, o).isMediaLoaded || e(this, f)) return;
  const s = e(this, o).duration, n = a(this, i, m).call(this, t);
  u(this, S, new E(0, s)), e(this, h).notify("duration-change", s, n);
}, G = function(t) {
  if (!e(this, o).isMediaLoaded) return;
  const s = {
    muted: e(this, o).isMuted,
    volume: e(this, o).volumeLevel
  }, n = a(this, i, m).call(this, t);
  e(this, h).notify("volume-change", s, n);
}, et = function(t) {
  const s = a(this, i, m).call(this, t);
  e(this, o).isPaused ? e(this, h).notify("pause", void 0, s) : e(this, h).notify("play", void 0, s);
}, V = function(t) {
  const s = {
    seekable: a(this, i, $).call(this),
    buffered: new E(0, e(this, p))
  }, n = t ? a(this, i, m).call(this, t) : void 0;
  e(this, h).notify("progress", s, n);
}, st = function(t) {
  const s = e(this, o).playerState, n = chrome.cast.media.PlayerState;
  if (u(this, w, s === n.IDLE), s === n.PAUSED) return;
  const c = a(this, i, m).call(this, t);
  switch (s) {
    case n.PLAYING:
      e(this, h).notify("playing", void 0, c);
      break;
    case n.BUFFERING:
      e(this, h).notify("waiting", void 0, c);
      break;
    case n.IDLE:
      e(this, v).stop(), e(this, h).notify("pause"), e(this, h).notify("end");
      break;
  }
}, $ = function() {
  return e(this, o).liveSeekableRange ? new E(e(this, o).liveSeekableRange.start, e(this, o).liveSeekableRange.end) : e(this, S);
}, m = function(t) {
  return t instanceof Event ? t : new x(t.type, { detail: t });
}, it = function(t) {
  const { streamType: s, title: n, poster: c } = e(this, h).$state;
  return new gt(t).setMetadata(n(), c()).setStreamType(s()).setTracks(e(this, C).getLocalTextTracks()).build();
}, nt = function(t) {
  var l, g;
  const s = a(this, i, it).call(this, t), n = new chrome.cast.media.LoadRequest(s), c = e(this, h).$state.savedState();
  return n.autoplay = (((l = e(this, f)) == null ? void 0 : l.paused) ?? (c == null ? void 0 : c.paused)) === !1, n.currentTime = ((g = e(this, f)) == null ? void 0 : g.time) ?? (c == null ? void 0 : c.currentTime) ?? 0, n;
}, H = async function(t, s) {
  const n = I(e(this, h).$state.source);
  u(this, f, { src: n, paused: t, time: s }), await this.loadSource(n);
}, at = function() {
  a(this, i, H).call(this, e(this, o).isPaused, e(this, o).currentTime).catch((t) => {
  });
};
const Lt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GoogleCastProvider: Et
}, Symbol.toStringTag, { value: "Module" }));
export {
  q as a,
  wt as b,
  Ct as c,
  kt as d,
  Tt as e,
  B as f,
  L as g,
  vt as h,
  At as i,
  Lt as p
};
